export const API_URL = process.env.REACT_APP_API_URL;
export const FILE_URL = process.env.REACT_APP_FILE_URL ?? "https://assets.flex2.io";
export const DEVICE_ENGERY_METER = "EN02";
export const DEVICE_DRYER_LOGIC = "DL01";
export const DL02 = "DL02";
export const QD01 = "QD01";
export const LIFT_LOGIC = "VL01";
export const QD02 = "QD02";
export const AC01 = "AC01";
export const DR02 = "DR02";
export const DR01 = "DR01";
export const CP02 = "CP02";
export const DP01 = "DP01";
export const DP02 = "DP02";
export const EN01 = "EN01";
export const QD03 = "QD03";
export const TA01 = "TA01";
export const DL03 = "DL03";
export const DL04 = "DL04";
export const MF01 = "MF01";
export const CP01 = "CP01";
export const LVL01 = "LVL01";
export const EN03 = "EN03";
export const CCTL01 = "CCTL01";
export const ENERGY_MASTER = "Energy_Master";

export const ADMIN_EMAILS = [
  "pankaj.singh@mailinator.com",
  "lee.snook@flex2.io",
  "tony@flex2.io",
  "pankaj.sandbox@gmail.com",
  "admin@flex2.io",
  "pankaj@yopmail.com",
];

export const STYLE_STATUS_LABLES = [
  {
    status: 0,
    label: "Provisioning",
  },
  {
    status: 1,
    label: "Active",
  },
  {
    status: 2,
    label: "InActive",
  },
];

export const SUBSCRIPTION_STATUS_LABLES = [
  {
    status: 0,
    label: "InActive",
  },
  {
    status: 1,
    label: "Active",
  },
  {
    status: 2,
    label: "Cancelled",
  },
];

export const SUBSCRIPTION_PAYMENT_STATUS_LABLES = [
  {
    status: 0,
    label: "Pending",
  },
  {
    status: 1,
    label: "Completed",
  },
  {
    status: 2,
    label: "Late",
  },
];

export const PAYMENT_STATUS_LABLES = [
  {
    status: 0,
    label: "Pending",
  },
  {
    status: 1,
    label: "Completed",
  },
  {
    status: 2,
    label: "Refunded",
  },
];

export const TIME_SENT_TIME_KEY = "tTimesent";
export const TIME_RECIEVED_TIME_KEY = "tTimerecieved";
export const DL01_TIME_KEY = "tTimesent";
export const CP02_TIME_KEY = "tTimerecieved";

export const TIME_INTERVALS = [
  { value: "5m", label: "5 Minutes", sample: "1s" },
  { value: "15m", label: "15 Minutes", sample: "1s" },
  { value: "30m", label: "30 Minutes", sample: "2s" },
  { value: "1h", label: "1 Hour", sample: "5s" },
  { value: "3h", label: "3 Hours", sample: "10s" },
  { value: "6h", label: "6 Hours", sample: "15s" },
  { value: "12h", label: "12 Hours", sample: "30s" },
  { value: "24h", label: "24 Hours", sample: "60s" },
];

export const TIME_SAMPLE_RATES = [
  { value: 5 * 60, label: "5 Minutes", sample: "1s" },
  { value: 30 * 60, label: "30 Minutes", sample: "2s" },
  { value: 60 * 60, label: "1 Hour", sample: "5s" },
  { value: 3 * 60 * 60, label: "3 Hours", sample: "10s" },
  { value: 6 * 60 * 60, label: "6 Hours", sample: "15s" },
  { value: 12 * 60 * 60, label: "24 Hours", sample: "30s" },
  { value: 24 * 60 * 60, label: "12 Hours", sample: "60s" },
  { value: 7 * 24 * 60 * 60, label: "7 Days", sample: "1h" },
  { value: 15 * 24 * 60 * 60, label: "15 Days", sample: "2h" },
  { value: 30 * 24 * 60 * 60, label: "30 Days", sample: "3h" },
  { value: 90 * 24 * 60 * 60, label: "60 Days", sample: "4h" },
  { value: 180 * 24 * 60 * 60, label: "180 Days", sample: "6h" },
];

export const DLO1_DATA_SOURCES = ["y1", "y2", "y3", "y4"];
export const AC01_DATA_SOURCES = ["y1", "y2", "y3", "y4"];
export const DL02_DATA_SOURCES = ["rTemp", "rPressure", "rDewpoint", "rFlow"];
export const DP01_DATA_SOURCES = ["rTemp", "rHumid", "rDewpoint", "rDewpointATM"];
export const DP02_DATA_SOURCES = [
  "rHumid",
  "rDewpoint",
  "rDewpointATM",
  "rPPM",
  "rTemperature",
  "rPressure",
];
export const EN01_DATA_SOURCES = ["rVoltsLN", "rTemp", "rAmps", "rKwHr"];
export const DR02_DATA_SOURCES = ["AC1_Enabled", "AC2_Enabled", "AC3_Enabled", "S1B0"];
export const DR01_DATA_SOURCES = ["rTemp", "rHumid", "y1", "rRoomTemp"];
export const QD03_DATA_SOURCES = ["y1", "y2", "y3", "y4"];
export const CP02_DATA_SOURCES = ["rPressure1", "rPressure2", "rTemp"];
export const TA01_DATA_SOURCES = ["rPressure1", "rPressure2", "rTemp2", "rAmps"];
export const DL03_DATA_SOURCES = ["rTemp", "rHumid", "rDewpoint", "rDewpointATM"];
export const DL04_DATA_SOURCES = ["rTemp", "rHumid", "rDewpoint", "rDewpointATM"];
export const MF01_DATA_SOURCES = ["y1", "y2", "y3", "y4", "rTemp", "rHumid"];
export const CP01_DATA_SOURCES = [
  "rTemp",
  "rHumid",
  "rCurrent",
  "rTemp1",
  "rTemp2",
  "rPressure",
  "xGreenLED",
  "xYellowLED",
  "xRedLED",
  "xBuzzer",
];

export const LVL01_DATA_SOURCES = [
  "rTemp",
  "rHumid",
  "rCurrent",
  "rTemp1",
  "rTemp2",
  "rPressure",
  "xGreenLED",
  "xYellowLED",
  "xRedLED",
  "xBuzzer",
];

export const EN03_DATA_SOURCES = ["rTemp", "rHumid"];
export const CCTL01_DATA_SOURCES = ["humidity", "temperature", "pressure"];

export const DL01_COMPLETE_DATA_SOURCES = [
  ...DLO1_DATA_SOURCES,
  "SP",
  "PV",
  "PIDOUT",
  "Tower 1",
  "Tower 2",
  "Tower 3",
  "Tower 4",
];

export const DL02_COMPLETE_DATA_SOURCES = [
  ...DL02_DATA_SOURCES,
  "rAmps",
  "Tower 1",
  "Tower 2",
  "Tower 3",
  "Tower 4",
];

export const DP01_COMPLETE_DATA_SOURCES = [...DP01_DATA_SOURCES, "rPPM"];
export const DP02_COMPLETE_DATA_SOURCES = [...DP02_DATA_SOURCES];
export const EN01_COMPLETE_DATA_SOURCES = [...EN01_DATA_SOURCES, "rHumid", "rVoltsLL"];
export const QD03_COMPLETE_DATA_SOURCES = [
  ...QD03_DATA_SOURCES,
  "y5",
  "y6",
  "y7",
  "y8",
  "rTemp",
  "rHumid",
];

export const MF01_COMPLETE_DATA_SOURCES = [...MF01_DATA_SOURCES];

export const CP01_COMPLETE_DATA_SOURCES = [
  ...CP01_DATA_SOURCES,
  "rHumid1",
  "rHumid2",
  "xAuxAlarm1",
  "xAuxAlarm2",
  "xAuxAlarm3",
  "xAuxAlarm4",
];

export const LVL01_COMPLETE_DATA_SOURCES = [
  ...LVL01_DATA_SOURCES,
  "rHumid1",
  "rHumid2",
  "xAuxAlarm1",
  "xAuxAlarm2",
  "xAuxAlarm3",
  "xAuxAlarm4",
];

export const CP02_COMPLETE_DATA_SOURCES = [...CP02_DATA_SOURCES];
export const EN03_COMPLETE_DATA_SOURCES = [
  ...EN03_DATA_SOURCES,
  "rCurrent1",
  "rCurrent2",
  "rCurrent3",
  "rCurrent4",
  "rCurrent5",
  "rCurrent6",
  "rCurrent7",
  "rCurrent8",
  "rCurrent9",
  "rCurrent10",
  "rCurrent11",
  "rCurrent12",
];
export const CCTL01_COMPLETE_DATA_SOURCES = [
  ...CCTL01_DATA_SOURCES,
  "comp1Runtime",
  "comp2Runtime",
  "comp1Loadedtime",
  "comp2Loadedtime",
];

export const DR02_COMPLETE_DATA_SOURCES = [
  ...DR02_DATA_SOURCES,
  "S1B1",
  "S1B2",
  "S1B3",
  "S1B4",
  "S1B5",
];

export const DR01_COMPLETE_DATA_SOURCES = [
  ...DR01_DATA_SOURCES,
  "rTstatSet",
  "In1",
  "In1",
  "In1",
  "In1",
  "Zone1Lock",
  "Zone2Lock",
  "TempLock",
  "ACLock",
];

export const TA01_COMPLETE_DATA_SOURCES = [
  ...TA01_DATA_SOURCES,
  "rTemp",
  "rKwHr",
  "rHumid",
  "rVoltsLN",
  "rVoltsLL",
  "rTemp1",
];

export const DL03_COMPLETE_DATA_SOURCES = [
  ...DP01_DATA_SOURCES,
  "rPPM",
  "rTemperature",
  "rPressure",
  "SP",
  "PV",
  "PIDOUT",
  "Tower 1",
  "Tower 2",
  "Tower 3",
  "Tower 4",
];

export const DL04_COMPLETE_DATA_SOURCES = [
  ...DL04_DATA_SOURCES,
  "rPPM",
  "rTemperature",
  "rPressure",
  "SP",
  "PV",
  "PIDOUT",
  "Tower 1",
  "Tower 2",
  "Tower 3",
  "Tower 4",
];

export const DL01_UNIT_KEYS = ["units1", "units2", "units3", "units4"];
export const DL01_UNITS = ["F", "F", "PSI", "CFM"];
export const DL02_UNITS = ["F", "PSI", "F", "CFM"];
export const QD01_UNITS = ["F", "PSI", "CFM", "CFM"];
export const QD02_UNITS = ["CFM", "PSI", "F", "PSI"];
export const AC01_UNITS = ["F", "RH", "F", "GPM"];
export const CP02_UNITS = ["PSI", "PSI", "F"];
export const DP01_UNITS = ["F", "P", "F", "F"];
export const DP02_UNITS = ["F", "F", "F", "F", "F", "PSI"];
export const EN01_UNITS = ["Voltage", "Temp", "Current", "Energy"];
export const DR02_UNITS = ["AC1", "AC2", "AC3", "Door1"];
export const DR01_UNITS = ["Temp", "Humid", "F", "RoomTemp"];
export const QD03_UNITS = ["F", "F", "PSI", "GPM"];
export const TA01_UNITS = ["PSI", "PSI", "F", "Amps"];
export const DL03_UNITS = ["F", "P", "C", "C"];
export const DL04_UNITS = ["F", "P", "C", "C"];
export const MF01_UNITS = ["F", "PSI", "F", "CFM", "F", "F"];
export const CP01_UNITS = [
  "F",
  "Humidity",
  "Current",
  "F",
  "F",
  "PSI",
  "Green",
  "Yellow",
  "Red",
  "Alarm",
];
export const CP012_UNITS = ["F", "Humidity", "Green", "Yellow", "Red", "Alarm"];
export const EN03_UNITS = [
  "V", // Voltage
  "C", // Temp
  "A", // Current
  "A",
  "A",
  "A",
  "A",
  "A",
  "A",
  "A",
  "A",
  "A",
  "A",
  "A",
];
export const CCTL01_UNITS = ["F", "F", "PSI"];
export const DL02_TIME_KEY = "tTimerecieved";
export const ENERGY_METER_DATA_SOURCES = ["rVolts", "rAmps", "rKwHr"];

export const ENERGY_METER_LABELS = [
  { id: "rVolts", label: "Voltage" },
  { id: "rAmps", label: "Current" },
  { id: "rKwHr", label: "Energy" },
];

export const ENERGY_METER_TIME_KEY = "tTime";

export const ENERGY_METER_UNIT_KEYS = ["Volts", "Amps", "KwHr"];

export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 5 MB, for examp

export const RELATED_ITEM_BOM = 4;

export const PRODUCT_TYPE_PRODUCT = 1;
export const PRODUCT_TYPE_PART = 2;

export const PRODUCT_TYPES = [
  { id: PRODUCT_TYPE_PRODUCT, label: "Product" },
  { id: PRODUCT_TYPE_PART, label: "Part" },
];

export const LITERS_TO_GALLONS = 0.264172;
